<template>
  <div class='label__page'>
    <section class="home" v-show="!loading">
      <tips :show.sync='tips_show' v-on:closeTips="handleCloseTips" class="zindex3"></tips>
      <img src="@/assets/home-tips.png" @click="handleOpenTips" alt="" class="tips">
      <share :show.sync='shareShow' v-on:closeShare="handleCloseShare" :poster.sync='posterDown'></share>
      <noprize :show.sync='noPrizeShow' v-on:openShare="handleOpenShare" v-on:again="handleOpenPrize"></noprize>
      <prize :show.sync='prizeShow' :noChange.sync='noChange' v-on:prizeClose="handlePrizeClose" v-on:noPrize="handleNoPrizeShow" :overTime.sync='overTime'></prize>
      <img src="@/assets/label-topIcon.png" alt="" class="topIcon">
      <img :src='poster' class="posterShow">
      <img :src='posterDown' class="posterDown">
      <img src="@/assets/home-musicOpen.png" @click="audioPause" v-show="music" alt="" class="yinyue">
      <img src="@/assets/home-musicClose.png" @click="audioAutoPlay" v-show="!music" alt="" class="yinyue">
      <div class="btns">
        <img src="@/assets/label-share.png" @click="handleOpenShare" alt="" class="btns__item">
        <img src="@/assets/label-get.png" @click="handleOpenPrize" alt="" class="btns__item">
      </div>
    </section>
    <section class="loading" v-show="loading">
      <img src="https://qhd-icbc.oss-cn-shenzhen.aliyuncs.com/poster-tag/label-loading-icon.gif" alt="" class="loading__main">
      <p class="loading__text">正在抽取“鼠”于你的2020新年签</p>
    </section>
  </div>
</template>

<script>
import tips from '@/components/tips'
import share from '@/components/share'
import noprize from '@/components/noPrize'
import prize from '@/components/prize'
import Maker from 'poster-maker'
import yinyue from '@/assets/yinyue.mp3'
import { loadBase64Img, loadImg } from '@/utils/poster'
const maker1 = new Maker({
  width: 610, // 海报最终生成的宽度
  height: 874, // 海报最终生成的高度
  backgroundColor: 'transparent'
})
const maker2 = new Maker({
  width: 750, // 海报最终生成的宽度
  height: 1334, // 海报最终生成的高度
  backgroundColor: 'transparent'
})
export default {
  data () {
    return {
      music: true,
      loading: true,
      timer: null,
      shareShow: false,
      noPrizeShow: false,
      prizeShow: false,
      noChange: false,
      maker: null,
      poster: '',
      posterDown: '',
      overTime: false,
      yinyue: yinyue,
      tips_show: false // 是否显现锦囊
    }
  },
  components: {
    share,
    noprize,
    prize,
    tips
  },
  methods: {
    // 音乐停止
    audioPause () {
      this.$parent.pause()
      this.music = false
    },
    // 音乐开始
    audioAutoPlay () {
      this.$parent.play()
      this.music = true
    },
    // 关闭锦囊
    handleCloseTips () {
      this.tips_show = false
    },
    // 打开锦囊
    handleOpenTips () {
      this.tips_show = true
    },
    handleOpenShare () {
      this.noPrizeShow = false
      this.shareShow = true
      this.$stat({
        event: 'share' // 上报埋点信息--分享有好运
      })
    },
    handleCloseShare () {
      this.shareShow = false
    },
    handleOpenPrize () {
      this.$stat({
        event: 'showPrizeBtn' // 上报埋点信息--领惊喜利是
      })
      this.handlePrizeClose()
      const overTime = JSON.parse(localStorage.getItem('setOverTime'))
      if (overTime) {
        this.overTime = true
        this.prizeShow = true
        return false
      }
      if (JSON.parse(localStorage.getItem('lotteryCount')) > 0) {
        this.prizeShow = true
        this.noChange = false
      } else {
        this.noChange = true
        this.prizeShow = true
      }
    },
    handleNoPrizeShow () {
      this.noPrizeShow = true
      this.prizeShow = false
    },
    handlePrizeClose () {
      this.noChange = false
      this.prizeShow = false
      this.noChange = false
      this.noPrizeShow = false
      this.overTime = false
    },
    async createPoster (type, num) {
      const img = require(`@/assets/label/${type}${num}.png`)
      const avatarDefault = localStorage.getItem('setAvatar') ? localStorage.getItem('setAvatar') : require('@/assets/default_avatar.png')
      let avatar = await loadBase64Img(avatarDefault)
      avatar = await loadImg(avatar)
      let text2 = ''
      localStorage.getItem('setNickname').length > 12 ? text2 = localStorage.getItem('setNickname').substring(0, 11) + '…' : text2 = localStorage.getItem('setNickname')
      await maker1.putImg({
        img: img,
        x: 0,
        y: 0,
        width: 610,
        height: 875
      })
      await maker1.putCircularImg({
        img: avatar,
        x: 70,
        y: 44,
        width: 80,
        height: 80
      })
      await maker1.putText({
        text: text2,
        x: 170,
        y: 68,
        fontSize: 30,
        fontWeight: '500',
        color: '#FFF'
      })
      const poster = await maker1.canvasToDataUrl()
      return poster
    },
    async createPoster2 (type, num) {
      const img = require(`@/assets/label/${type}${num}.png`)
      const qrCode = require('@/assets/qrcode.jpeg')
      const avatarDefault = localStorage.getItem('setAvatar') ? localStorage.getItem('setAvatar') : require('@/assets/default_avatar.png')
      let avatar = await loadBase64Img(avatarDefault)
      avatar = await loadImg(avatar)
      let text2 = ''
      localStorage.getItem('setNickname').length > 12 ? text2 = localStorage.getItem('setNickname').substring(0, 11) + '…' : text2 = localStorage.getItem('setNickname')
      await maker2.putImg({
        img: img,
        x: 0,
        y: 0,
        width: 750,
        height: 1334
      })
      await maker2.putCircularImg({
        img: avatar,
        x: 72,
        y: 34,
        width: 100,
        height: 100
      })
      await maker2.putImg({
        img: qrCode,
        x: 562,
        y: 1165,
        width: 130,
        height: 130
      })
      await maker2.putText({
        text: text2,
        x: 200,
        y: 70,
        fontSize: 35,
        fontWeight: '500',
        color: '#FFF'
      })
      const poster = await maker2.canvasToDataUrl()
      return poster
    }
  },
  async mounted () {
    this.setWxShare()
    this.audioAutoPlay()
    let num = null
    if (this.$route.query.reload) {
      num = Math.floor(Math.random() * 20 + 1)
      localStorage.setItem('setNum', num)
    } else {
      num = localStorage.getItem('setNum')
    }
    this.poster = await this.createPoster('show', num)
    this.posterDown = await this.createPoster2('down', num)
    this.timer = setTimeout(() => {
      this.loading = false
    }, 1500)
  },
  beforeDestroy() {
    this.$parent.pause()
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style lang="scss" scope>
#bgMusic {
    position: fixed;
    top: -500px;
    left: 0;
    opacity: 0;
}
.label__page{
  .tips{
    position: absolute;
    top: 0;
    z-index: 2;
    right: 22px;
    width: 63px;
    height: 105px;
  }
  .zindex3{
    position: absolute;
    z-index: 3;
  }
  .force{
    position: absolute;
    z-index: 2;
  }
  @mixin main ($url){
    min-height: 1208px;
    height: 100vh;
    position: relative;
    background: url($url);
    background-size: 100%;
  }
  .loading{
    @include main('https://qhd-icbc.oss-cn-shenzhen.aliyuncs.com/poster-tag/label-loading-bg.png');
    &__main{
      position: absolute;
      width: 543px;
      right: 0;
      left: 0;
      top: 300px;
      margin: auto;
    }
    &__text{
      position: absolute;
      top: 689px;
      width: 100vw;
      text-align: center;
      font-size:31px;
      font-family:Source Han Sans CN;
      font-weight:500;
      color:#B12928;
    }
  }
  .home{
    @include main('https://qhd-icbc.oss-cn-shenzhen.aliyuncs.com/poster-tag/label-bg.png');
    .posterShow{
      position: absolute;
      top: -900px;
      width: calc(100vw - 100px);
      right: 0;
      left: 0;
      margin: auto;
      animation: 2.5s down forwards;
    }
    .posterDown{
      position: absolute;
      z-index: 1;
      top: 35px;
      width: calc(100vw - 200px);
      right: 0;
      left: 0;
      margin: auto;
      opacity: 0;
    }
    @keyframes down {
      0% { top: -900px; }
      95% { top: 42px; }
      100% {top: 35px; }
    }
    .btns{
      height: 100px;
      position: absolute;
      top: 1050px;
      padding: 0 55px;
      &__item{
        width: 319px;
      }
    }
  }
  .yinyue{
    z-index: 1;
    position: absolute;
    top: 40px;
    left: 28px;
    width: 70px;
    animation: 4s rotated infinite linear;
  }
  @keyframes rotated {
    0% { transform: rotate(0deg) };
    100% { transform: rotate(360deg) };
  }
  .topIcon{
    z-index: 1;
    position: absolute;
    top: 0;
  }
}
</style>